import React from "react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import SpringBtn from "../../common/springBtn";

function Navbar() {
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-3 place-content-center items-center px-6 md:px-0 py-4 md:py-10">
      {/* Back Button */}
      <div className="flex items-center justify-start">
        <SpringBtn
          onClick={() => {
            navigate("/");
          }}
          className="block group text-gray-700 md:hover:text-white leading-[3rem] rounded-2xl overflow-hidden transition"
        >
          <span className="px-4 md:bg-gray-50 md:group-hover:bg-gray-700 transition flex items-center gap-1">
            <ChevronLeft
              className="w-5 h-5"
            />
            <span className="hidden md:inline mr-1">Back</span>
          </span>
        </SpringBtn>
      </div>
      {/* LOGO */}
      <div className="text-center">
        <h1 className="text-xl md:text-3xl font-bold">Stylo</h1>
      </div>
    </div>
  );
}

export default Navbar;
